import { usePermissions } from '../../../common/hooks/usePermissions';

function usePromotionPermission() {
  const { hasPermission } = usePermissions('PROMOTION_RELEASE_EDIT');
  return hasPermission;
}

export default usePromotionPermission;
